import { useFilters } from "@/components/filters";
import { Stack, StackProps } from "@mui/material";
import { useGetAllCajaAperturaDetailsQuery } from "../api/get-all-caja-apertura-details";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { formatDate } from "@/shared/formats";
import { Dialog, ModalHeader, ModalValueExtractor, useOpenModal } from "@/components/modal";
import { GetCajaAperturaDetailQuery } from "../api/get-caja-apertura-detail";
import { DataFetcher } from "@/components/display";
import SharedViewCajaAperturaMovimientos from "../../shared/components/shared-view-caja-apertura-movimientos";
import SharedViewCajaMovimiento from "../../shared/components/shared-view-caja-movimiento";

export interface ViewCajaAperturaMovimientosProps extends StackProps {
    cajaApertura: CajaApertura
}

export default function ViewCajaAperturaMovimientos({
    cajaApertura,
    ...props
}: ViewCajaAperturaMovimientosProps) {
    const openModal = useOpenModal();

    const filterData = useFilters({
        filters: [
            { type: "dateRange", label: "Fecha", fromName: "desde", toName: "hasta" },
            { type: "pagination" }
        ],
        useURL: false,
    })

    const fetchData = useGetAllCajaAperturaDetailsQuery(cajaApertura.id, filterData.filterData);

    return <Stack gap={3} {...props}>
        <SharedViewCajaAperturaMovimientos
            fetchData={fetchData}
            filterData={filterData}
            onViewCajaMovimientoClick={(_, movimiento) => openModal("viewMovimiento", movimiento.id)}
        />
        <Dialog code="viewMovimiento" size="md">
            <ModalValueExtractor>
                {movimientoId => <GetCajaAperturaDetailQuery aperturaId={cajaApertura.id} movimientoId={movimientoId}>
                    {query => <DataFetcher query={query} flex={1}>
                        {movimiento => <>
                            <ModalHeader>Movimiento de Caja - {formatDate(movimiento.fecha, true)}</ModalHeader>
                            <SharedViewCajaMovimiento
                                cajaMovimiento={movimiento}
                                padding={3}
                                flex={1}
                            />
                        </>}
                    </DataFetcher>}
                </GetCajaAperturaDetailQuery>}
            </ModalValueExtractor>
        </Dialog>
    </Stack>
}